export default {

	// AEE

	async page_list (params) {

		const [ aees, companies, company_dbs, sites, terminals ] = await Promise.all([
			Anvil.models.c_order.AEEList.fetch(),
			Anvil.models.CompanyList.fetch(),
			Anvil.models.c_order.CompanyDBList.fetch(),
			Anvil.models.c_order.SiteList.fetch(),
			Anvil.models.c_order.TerminalList.fetch()
		])

		const search = new Anvil.models.Record({
			operator_service_id: params.operator_service_id || null,
			partner_service_id: params.partner_service_id || null,
			inspection_due: params.inspection_due || null,
			ap_list: params.ap_list || null,
			expression: params.expression || '',
			sort_order: params.sort_order || ''
		})

		await Anvil.renderPage('/c_order/aee/page_list', { aees, companies, company_dbs, sites, terminals, search })
	},

	async action_refresh () {

		const [ aees, companies, company_dbs, sites, terminals ] = await Promise.all([
			Anvil.models.c_order.AEEList.fetch(),
			Anvil.models.CompanyList.fetch(),
			Anvil.models.c_order.CompanyDBList.fetch(),
			Anvil.models.c_order.SiteList.fetch(),
			Anvil.models.c_order.TerminalList.fetch()
		])

		Anvil.page.aees = aees
		Anvil.page.companies = companies
		Anvil.page.company_dbs = company_dbs
		Anvil.page.sites = sites
		Anvil.page.terminals = terminals
		Anvil.models.components.Grid.find('#aee_grid').list = aees
	},

	async modal_edit (id) {

		const [ aee, companies, company_dbs ] = await Promise.all([
			Anvil.models.c_order.AEE.fetch(id),
			Anvil.models.CompanyList.fetch(),
			Anvil.models.c_order.CompanyDBList.fetch()
		])
		//const terminal = new Anvil.models.c_order.Terminal(terminal_data)

		await Anvil.modal('/c_order/aee/modal_edit', { aee, companies, company_dbs })
	},

	async action_save (aee) {

		// Validate
		if (aee.licence_to_upload) {

			// Sanitize licence_to_upload
			aee.licence_to_upload = aee.licence_to_upload.trim()

			const regex = /([A|Y][0-9]{8})MolSoft([0-9]{4}\. ?[0-9]{2}\. ?[0-9]{2}\. [0-9]{1,2}\:[0-9]{2}\:[0-9]{2})Informatika/gmi
			const lic = Buffer.from(aee.licence_to_upload, 'base64').toString('utf8')
			const lic_data = regex.exec(lic)

			if (!lic_data || lic_data[1] != aee.ap) {
				Anvil.toast.warning('Hiba', 'A feltöltendő új licenc kód nem megfelelő!')
				return
			}
		}

		// Tell the record to commit
		await aee.record.commit()

		Anvil.toast.success('Elmentve', 'A pénztárgép adatainak mentése sikeres')

		return true
	},

	async action_delete (id, confirm = false) {

		// Megerősítés kérése
		if (!confirm) {
			Anvil.confirm({
				title: 'Törlés megerősítése',
				message: '<p>Valóban törölni szeretné a kijelölt pénztárgépet a nyilvántartásból?</p>',
				btn_ok: '<i class="fas fa-trash me-2"></i>Törlés',
				btn_ok_class: 'danger',
				btn_cancel: '<i class="fas fa-times me-2"></i>Mégsem',
				onclose: (confirmed) => {
					if (confirmed) {
						Anvil.exec('c_order/aee/action_delete', id, true)
					}
				}
			})
			return
		}

		await Anvil.models.c_order.AEE.delete(id)

		Anvil.toast.success('Törölve', 'A pénztárgép nyilvántartásból való törlése sikeres')

		// Refresh list
		await this.action_refresh()
	},

	// AEE Event

	async page_log ({ aee_id }) {

		const [ aee, aee_events ] = await Promise.all([
			Anvil.models.c_order.AEE.fetch(aee_id),
			Anvil.models.c_order.AEEEventList.fetch(aee_id)
		])

		await Anvil.renderPage('/c_order/aee_event/page_log', { aee, aee_events })
	},

	async action_refresh_log () {

		const aee_id = Anvil.page.aee.id

		const [ aee_events ] = await Promise.all([
			Anvil.models.c_order.AEEEventList.fetch(aee_id)
		])

		Anvil.page.aee_events = aee_events
		Anvil.models.components.Grid.find('#aee_event_grid').list = aee_events
	}
}